/**
 * Copyright 2024 Beijing Volcano Engine Technology Co., Ltd. All Rights Reserved.
 * SPDX-license-identifier: BSD-3-Clause
 */

/*
 * On initiation. `engine` is not attached to any project or room for any specific user.
 */

const config = {
  appId: '679216a3ca76be01f841208e',
  roomId: 'ChatRoom01',
  tokens: [
    {
      userId: 'dev',
      token: '001679216a3ca76be01f841208eQwC2OiUF2CSrZ1hftGcKAENoYXRSb29tMDEDAGRldgYAAABYX7RnAQBYX7RnAgBYX7RnAwBYX7RnBABYX7RnBQBYX7RnIADcxYTCEUYe0mTQxpDNnngAyIQ/VafhzW+vKFfYcHuGvQ==',
    },
    {
      userId: 'test',
      token: '001679216a3ca76be01f841208eRABLl0cB8iSrZ3JftGcKAENoYXRSb29tMDEEAHRlc3QGAAAAcl+0ZwEAcl+0ZwIAcl+0ZwMAcl+0ZwQAcl+0ZwUAcl+0ZyAA55don8O2oXpCChamZmxiEzI4BdPOsdaziKFJ2gvHqyQ=',
    }
  ],
};

export default config;
